import React from 'react';
import { useDashboardVariant } from '../../data/domains/config';
import { DashboardScrollableGridCardSet1 } from './variants/set1/DashboardScrollableGridCardSet1';
import { DashboardScrollableGridCardSet2 } from './variants/set2/DashboardScrollableGridCardSet2';
import { DashboardScrollableGridCardSet3 } from './variants/set3/DashboardScrollableGridCardSet3';
import type { ThemeColors } from '../../shared/theme';
import type { ViewStyle } from 'react-native';

export interface DashboardScrollableGridCardProps {
  colors: ThemeColors;
  items: React.ReactNode[];
  on_container_press?: () => void;
  num_columns?: number;
  item_gap?: number;
  max_height?: number;
  title?: string;
  key_extractor?: (index: number) => string;
  style?: ViewStyle;
  content_container_style?: ViewStyle;
}

export function DashboardScrollableGridCard(props: DashboardScrollableGridCardProps) {
  const variant = useDashboardVariant();

  if (variant === 'set1') {
    return <DashboardScrollableGridCardSet1 {...props} />;
  }
  if (variant === 'set2') {
    return <DashboardScrollableGridCardSet2 {...props} />;
  }
  return <DashboardScrollableGridCardSet3 {...props} />;
}
